<template>
    <div class="task-content">
        <div class="sort-list">
            <div class="item">
                <span class="sort-text">训练分类：</span>
                <span class="sort-item" :class="{current: currentSort === -1}" @click="chooseSort(-1)">全部</span>
                <span class="sort-item"
                      :class="{current: currentSort === sortItem.id}"
                      v-for="sortItem in sortList"
                      :key="sortItem.id"
                      @click="chooseSort(sortItem.id)">
                    {{sortItem.title}}
                </span>
            </div>
            <div class="item">
                <span class="sort-text">训练筛选：</span>
                <span class="sort-item" :class="{current: currentSelect === -1}" @click="chooseSelect(-1)">全部</span>
                <span class="sort-item"
                      :class="{current: currentSelect === selectItem.id}"
                      v-for="selectItem in selectTask"
                      :key="selectItem.id"
                      @click="chooseSelect(selectItem.id)">
                    {{selectItem.name}}
                </span>
            </div>
            <div class="item">
                <span class="sort-text">条件筛选：</span>
                <span class="sort-item" :class="{current: currentCondition === -1}" @click="chooseCondition(-1)">全部</span>
                <span class="sort-item"
                      :class="{current: currentCondition === conditionItem.id}"
                      v-for="conditionItem in selectCondition"
                      :key="conditionItem.id"
                      @click="chooseCondition(conditionItem.id)">
                    {{conditionItem.name}}
                </span>
            </div>
        </div>
        <div :native="false" class="task-page">
            <div class="task-list" v-if="companyTaskList.length !== 0">
                <div class="list-item" v-for="item in companyTaskList" @click="viewCompanyTaskDetail(item)">
                    <div class="container">
                        <div class="item-cover">
                            <img :src="item.task_cover" alt="">
                            <!--<img v-if="item.enroll" src="../../assets/img/image/no-apply.png" class="sign" alt="">-->
                            <img v-if="item.enroll === '已报名'" src="../../assets/img/image/applyed.png" class="sign" alt="">
                            <img v-if="item.enroll === '需报名'" src="../../assets/img/image/need-apply.png" class="sign" alt="">
                            <img v-if="item.enroll === '合作咨询'" src="../../assets/img/image/hezuo.png" class="sign" alt="">
                        </div>
                        <div class="item-content">
                            <span class="item-title">{{item.task_title}}</span>
                            <div class="item-info">
                                <div class="item-author">
                                    <div class="item-avatar">
                                        <img :src="item.head_portrait ? item.head_portrait : require('../../assets/img/image/user_img.png')" alt="">
                                        <span>{{item.name}}</span>
                                    </div>
                                    <span>{{item.create_time}}</span>
                                </div>
                                <div class="item-evaluate">
                                    <div class="evaluate-status">
                                        悬赏金额:
                                        <span>{{item.task_money}}</span>
                                    </div>
                                    <span class="evaluate-num" v-if="item.enroll === '合作咨询'">参与人数:{{item.task_number_num}}人</span>
                                    <span class="evaluate-num" v-else-if="item.join_num === '不限制'">参与人数:{{item.join_num}}</span>
                                    <span class="evaluate-num" v-else>参与人数:{{item.join_num}}人</span>
                                </div>
                            </div>
                        </div>
                        <div class="item-status">
                            <span class="view-task" v-if="item.state === 2">查看训练 ></span>
                            <span class="finish-task" v-if="item.state === 1">已完成</span>
                            <span class="time-out-task" v-if="item.state === 0">已截止</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="task-list no-task-list">
                <span>暂无数据</span>
            </div>
            <el-pagination
                    v-if="companyTaskList.length > 0"
                    class="pages-center"
                    :current-page="companyPages.currentPageNum"
                    :page-size="companyPages.eachPageNum"
                    layout="prev, pager, next, jumper"
                    :total="companyPages.total"
                    @current-change="companyCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CompanyTask",
        data() {
            return {
                //训练分类
                sortList:[],
                currentSort: -1,
                //训练筛选
                selectTask: [
                    {
                        id: 0,
                        name: '已截止'
                    },
                    {
                        id: 1,
                        name: '已完成'
                    },
                    {
                        id: 2,
                        name: '未完成'
                    }
                ],
                currentSelect: -1,
                //条件筛选
                selectCondition: [
                    {
                        id: 0,
                        name: '无需报名'
                    },{
                        id: 1,
                        name: '需报名'
                    },{
                        id: 3,
                        name: '合作咨询'
                    }
                ],
                currentCondition: -1,
                //学生端获取的训练列表：包括教师训练和企业训练
                companyTaskList: [],
                //分页
                companyPages: {
                    currentPageNum: 1,
                    eachPageNum: 12,
                    total: 0
                },
            }
        },
        mounted() {
            this.getTaskType();
            this.getCompanyTaskList();
        },
        methods: {
            //训练分类
            getTaskType() {
                this.$httpStudent.axiosGet(this.$api.taskTypeList, (res) => {
                    this.sortList = res;
                }, (err) => {
                    console.log(err)
                })
            },
            //选择训练分类
            chooseSort(id) {
                this.currentSort = id;
                this.getCompanyTaskList();
            },
            //训练筛选
            chooseSelect(id) {
                this.currentSelect = id;
                this.getCompanyTaskList();
            },
            //条件筛选
            chooseCondition(id) {
                this.currentCondition = id;
                if(id === 3){
                    this.getIntelligentList();
                } else {
                    this.getCompanyTaskList();
                }
            },
            getIntelligentList(){
                let param = {
                    page: this.companyPages.currentPageNum,
                    limit: this.companyPages.eachPageNum
                }
                this.$httpStudent.axiosGetBy(this.$api.intelligent_getTaskCooperationList, param,res=>{
                    if(res.code == 200){
                        this.companyTaskList = res.data.data;
                        this.companyPages.total = res.data.total;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            //训练列表
            getCompanyTaskList() {
                let param = {
                    type: 2,
                    page: this.companyPages.currentPageNum,
                    limit: this.companyPages.eachPageNum
                }

                if (this.currentSort === -1) {
                    delete param.task_type_id
                } else {
                    param.task_type_id = this.currentSort;
                }
                if (this.currentSelect === -1) {
                    delete param.task_state
                } else {
                    param.task_state = this.currentSelect;
                }
                if (this.currentCondition === -1) {
                    delete param.task_condition
                } else {
                    param.task_condition = this.currentCondition;
                }

                this.$httpStudent.axiosGetBy(this.$api.studentTaskList, param, (res) => {
                    if (res.code === 200) {
                        this.companyTaskList = res.list;
                        this.companyPages.total = res.total;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                }, (err) => {
                    console.log(err)
                })
            },
            //查询学生合作咨询的训练
            getHezuo() {
                let param = {
                    page: this.companyPages.currentPageNum,
                    limit: this.companyPages.eachPageNum
                }
                this.$httpStudent.axiosGetBy(this.$api.intelligent_getTaskCooperationList, param, (res) => {
                    if (res.code === 200) {
                        this.companyTaskList = res.data.data;
                        this.companyPages.total = res.data.total;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                }, (err) => {
                    console.log(err)
                })
            },
            //分页
            companyCurrentChange(val){
                this.companyPages.currentPageNum = val;
                this.getCompanyTaskList();
            },
            //查看训练详情
            viewCompanyTaskDetail(item) {
                if(item.userData){
                    this.$router.push({
                        path: '/student/task/detail',
                        query: {
                            id: item.task_id,
                            user_id:item.userData[0].user_account_id
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/student/task/detail',
                        query: {
                            id: item.task_id
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .task-content {
        height: 100%;
        min-height: calc(100vh - 172px);
        display: flex;
        flex-direction: column;
        .task-page {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex: 1;
            height: 1%;
        }
        .sort-list {
            padding-left: 10px;
            .item {
                padding: 0 10px;
                margin: 0 0 15px 0;
                color: #666;
                cursor: pointer;
            }
            .sort-item {
                display: inline-block;
                padding: 2px 6px;
                margin: 0 5px;
            }
            .sort-item.current, .sort-item:hover {
                background: #BEC3F1;
                color: #2338E6;
                border-radius:4px;
            }
        }
        .task-list {
            /*margin-top: 20px;*/
            padding-left: 24px;
            margin-right: -20px;
            display: flex;
            flex-wrap: wrap;
            .list-item {
                width: calc(16% - 14px);
                margin: 20px 20px 0 0;
                border-radius: 8px;
                .container {
                    width: 100%;
                    border: 1px solid #E3E4EC;
                    transition: all .25s ease-out;
                    border-radius: 8px;
                    cursor: pointer;
                    .item-cover {
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 138px;
                        img {
                            max-width: 100%;
                            max-height: 100%;
                            /*border-radius:8px 8px 0 0;*/
                        }
                        img.sign {
                            position: absolute;
                            border-radius: 0;
                            top: 25px;
                            left: 0;
                            opacity: .8;
                            width: 80px;
                        }
                    }
                    .item-content {
                        padding: 10px;
                        .item-title {
                            display: block;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                        }
                        .item-info {
                            .item-author {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                .item-avatar {
                                    display: flex;
                                    align-items: center;
                                    margin: 10px 0;
                                    img {
                                        width: 24px;
                                        height: 24px;
                                        margin-right: 10px;
                                        border-radius: 50%;
                                    }
                                    span {
                                        display: block;
                                        width: 50px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                }
                            }
                            .item-evaluate {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                font-size: 12px;
                                i {
                                    color: #F19149;
                                    margin-right: 2px;
                                }
                            }
                        }
                    }
                    .item-status {
                        height: 38px;
                        line-height: 38px;
                        text-align: center;
                        margin: 0 10px;
                        border-top: 1px solid #E5E5E5;
                        .view-task {
                            color: #2338E6;
                        }
                        .finish-task {
                            color: #20C997;
                        }
                        .time-out-task {
                            color: #666666;
                        }
                    }
                }
            }
        }
        .no-task-list {
            height: 300px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .pages-center {
            margin-bottom: 10px;
            margin-top: 0;
        }
        /*.task-page {*/
            /*height: calc(100% - 116px);*/
            /*::v-deep .el-scrollbar__wrap {*/
                /*overflow-x: hidden;*/
                /*padding: 0 40px;*/
            /*}*/
        /*}*/
    }
</style>
